<template>

    <span class="traplinkedNotificationsWrapper" v-if="traplinkedNotifications">
      <span v-for="traplinkedNotification in traplinkedNotifications" :key="traplinkedNotification.name + '-' + refreshKey">
        <traplinked-notification :value="traplinkedNotification" :customer="customer" @quiet-hours-saved="refresh" />
      </span>
    </span>

</template>

<script>

    import axios from 'axios';
    axios.defaults.withCredentials = true;
    import TraplinkedNotification from '@/components/customer/TraplinkedNotification';

    export default {
      name: 'TraplinkedNotifications',
      components: {
        TraplinkedNotification
      },
      props: [
        /** customer kann auch ein Objekt mit ID 'ALLE' sein, um für alle Standorte des Keyusers Werte zu setzen */
        'customer'
      ],
      data() {
        return {
          /** mögliche Notifications */
          traplinkedNotifications: null,
          /**
           * SENSOR_ALARM und DOOR_ALARM teilen sich dieselben Ruhezeiten-Felder, laufen aber
           * als getrennte Komponenten - nach dem Speichern in einer Zeile werden hiermit alle
           * Zeilen neu vom Server geladen UND neu gemountet (via :key), damit die Geschwister-
           * Zeile ihre lokal zwischengespeicherten Werte ebenfalls aktualisiert
           */
          refreshKey: 0
        }
      },
      watch: {

        customer: function () {
          this.init()
        }

      },
      created() {

        this.init()

      },
      methods: {

        refresh: function () {

          this.refreshKey++
          this.init()

        },
        init: function () {

            const url    = process.env.VUE_APP_SERVER_URL + '/notification/listTraplinkedNotifications'
            let mandant = null
            if (this.customer) {
              mandant = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
            }
            const params = {
              cardcode:             this.customer ? this.customer.cardcode : null,
              mandant:              this.customer ? mandant : null,
              biotechUser_id:       this.$store.getters.user.id,
            }

            const that = this
            axios({
              method: 'get',
              params: params,
              url: url
            }).then(response => {

                if (response.data) {
                  that.traplinkedNotifications = response.data
                }

            }).catch(error => {
              console.log(error)
            })

          }

      }

    }

</script>
